import styled from 'styled-components'

export const Container = styled.div`
  background-color: var(--black);
`
export const ContainerButton = styled.div`
  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
  }
`
export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  @media (max-width: 825px) {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    grid-row-gap: 20px;
  }
`
export const CondicoesCompra = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  input {
    flex-shrink: 0;
    position: relative;
    width: 20px;
    height: 20px;
    margin-right: 10px;
    appearance: none;
    padding: 0px;
    background: var(--dark-text-color);
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease 0s;
    overflow: hidden;

    &:checked {
      background: var(--orange);
    }

    &:focus {
      border-color: var(--dark-text-color) 1px solid;
    }

    &::after {
      content: '';
      position: absolute;
      width: 4px;
      height: 7px;
      border-width: 0px 2px 2px 0px;
      border-right-style: solid;
      border-bottom-style: solid;
      border-right-color: var(--primary);
      border-bottom-color: var(--primary);
      border-image: initial;
      border-top-style: initial;
      border-top-color: initial;
      border-left-style: initial;
      border-left-color: initial;
      left: 5px;
      top: -15px;
      transform: rotate(43deg);
      opacity: 0;
      transition: all 0.2s ease-in 0s;
    }
    &:checked::after {
      top: 2px;
      opacity: 1;
    }
  }
  > label {
    order: 1;
    color: var(--primary);
    font-weight: 400;
    font-size: 16px;
    span {
      cursor: pointer;
      color: var(--orange);
    }
  }
`
export const PaymentSelected = styled.div`
  width: 100%;
  background-color: var(--gray-light);
  border-radius: 5px;
  padding: 20px;
  ul {
    padding-bottom: 15px;
    list-style: none;
    li {
      font-size: 16px;
      color: var(--primary);
      font-weight: 400;
      margin: 0 0 10px 0;
    }
  }
`
export const PaymentSelectedTitle = styled.h1`
  font-size: 18px;
  color: var(--primary);
  font-weight: 500;
  margin-bottom: 15px;
`
export const ContainerModal = styled.div`
  display: block;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  width: 100%;
  max-height: calc(100vh - 50px);
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-track {
    background: var(--scroll-track);
    border-radius: 5px;
  }
  ::-webkit-scrollbar-thumb {
    background: var(--gray-light);
  }

  h1 {
    color: var(--primary);
    font-size: 25px;
    font-weight: 700;
    padding-bottom: 20px;
  }
  > div.modal_buttons {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  > div.condicoes {
    color: var(--primary);
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 20px;
  }
`
